import React from 'react';
import {Alert} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleInfo} from "@fortawesome/free-solid-svg-icons";
import {useTranslation} from "react-i18next";

const NoElementsAlert = ({show, text = null, icon = faCircleInfo, className= null, variant = 'warning'}) => {
    const {t} = useTranslation()

    if(!show)
        return null;

    if(!text)
        text = t('dialogs.nothingFound')

    return (
        <div className='d-flex justify-content-center'>
            <Alert variant={variant} className={`w-100 my-2 ${className}`}>
                <FontAwesomeIcon icon={icon}/>
                <span className='ms-2'>{text}</span>
            </Alert>
        </div>
    );
};

export default NoElementsAlert;